<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t("municipality.municipalities") }}</h2>
    </div>
    <el-card
      v-if="checkRole(['Admin'])"
      class="box-card filter-card just-for-admin"
    >
      <div slot="header" class="clearfix">
        <span>{{ $t("general.filter") }}</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="initSearch"
        >{{ $t("general.init") }}</el-button>
      </div>
      <div class="filter-container">
        <el-radio
          v-model="activeList"
          label="actives"
          border
          @change="getSubMunicipalitiesList('indexactive')"
        >{{ $t("general.F_actives") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="desactives"
          border
          @change="getSubMunicipalitiesList('indexdesactive')"
        >{{ $t("general.F_desactives") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="disponibles"
          border
          @change="handleFilterMunicipalities"
        >{{ $t("general.disponibles") }}</el-radio>
        <el-radio
          v-model="activeList"
          label="corbeille"
          class="danger-radio"
          border
          @change="getSubMunicipalitiesList('indexinvisible')"
        >{{ $t("general.corbeille") }}</el-radio>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input
          v-model="query.keyword"
          clearable
          :placeholder="$t('general.keyword')"
          class="wd-200 mr-15 filter-item"
          @keyup.enter.native="handleFilterMunicipalities"
        />
        <el-select
          v-model="query.department_id"
          class="filter-item"
          filterable
          clearable
          :placeholder="$t('department.department')"
          @change="handleFilterMunicipalities"
        >
          <el-option
            v-for="(department, index) in departments"
            :key="index"
            :label="department.name | uppercaseFirst"
            :value="department.id"
          />
        </el-select>
        <el-button
          v-waves
          class="mr-15 filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleFilterMunicipalities"
        >
          {{ $t("general.search") }}
        </el-button>
        <el-button
          v-waves
          :loading="downloading"
          class="filter-item"
          type="primary"
          icon="el-icon-download"
          @click="handleDownload"
        >
          {{ $t("general.export") }}
        </el-button>
        <el-button
          v-waves
          class="filter-item"
          type="primary"
          icon="el-icon-upload"
          @click="handleImportMunicipalities"
        >
          {{ $t('general.import') }}
        </el-button>
        <input
          ref="fileInput"
          type="file"
          style="display: none"
          accept=".xlsx, .xls"
          @change="onFileChange"
        >

        <el-button
          v-if="checkPermission(['create municipality'])"
          class="mr-15 filter-item"
          type="primary"
          icon="el-icon-plus"
          @click="handleCreateMunicipalitie"
        >
          {{ $t("general.add") }}
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column align="center" :label="$t('general.reference')" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.ref }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('municipality.name')">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('department.department')" width="200">
          <template slot-scope="scope">
            <!-- <span>
              {{ departments.find((department) => department.id == scope.row.department_id)?.name??'' }}
            </span> -->
            <span>{{ scope.row.department.name }}</span>
          </template>
        </el-table-column>

        <el-table-column
          v-if="
            activeList != 'corbeille' && checkPermission(['activate municipality'])
          "
          align="center"
          :label="$t('general.status')"
          width="150"
        >
          <template slot-scope="scope">
            <el-switch
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_active"
              :disabled="!scope.row.is_visible"
              @change="setMunicipalitieStatus(scope.row.id, 'active')"
            />
          </template>
        </el-table-column>

        <el-table-column
          v-if="
            checkRole(['Admin']) && (activeList == 'corbeille' || query.keyword)
          "
          align="center"
          :label="$t('general.restaurer')"
          width="100"
        >
          <template slot-scope="scope">
            <el-switch
              v-if="!scope.row.is_visible"
              style="display: block"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :active-value="true"
              :inactive-value="false"
              :value="scope.row.is_visible"
              @change="setMunicipalitieStatus(scope.row.id, 'visible')"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="checkPermission(['edit municipality', 'hide municipality', 'delete municipality'])"
          align="center"
          :label="
            1 == 1 ? $t('general.actions') : $t('general.suppressionDefinitive')
          "
          width="150"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.is_visible && checkPermission(['edit municipality'])"
              type="primary"
              size="small"
              icon="el-icon-view"
              style="margin-right: 10px"
              @click="handleEditMunicipalitie(scope.row.id)"
            />
            <el-button
              v-if="checkPermission(['hide municipality', 'delete municipality'])"
              slot="reference"
              type="danger"
              size="small"
              icon="el-icon-delete"
              style="margin-right: 10px"
              @click="
                handleDeleteMunicipalitie(
                  scope.row.id,
                  scope.row.is_visible,
                  scope.row.name
                )
              "
            />
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="query.page"
        :limit.sync="query.limit"
        @pagination="getMunicipalitiesList"
      />

      <!-- ======= Municipalitie FORM ======= -->
      <el-dialog
        :title="
          editing
            ? $t('municipality.edit') + ' ' + currentMunicipalitie.name
            : $t('municipality.AddMunicipalitie')
        "
        :visible.sync="dialogCreateMunicipalitie"
        :before-close="handleCloseMunicipalitieCreateDraw"
        :loading="municipalitieCreating"
        width="50%"
      >
        <div class="content-inputs">
          <el-form
            ref="municipalitieForm"
            :rules="rules"
            :model="currentMunicipalitie"
            label-position="left"
          >
            <el-form-item
              :label="$t('department.selectDepartmentTitle')"
              prop="department_id"
            >
              <el-select
                v-model="currentMunicipalitie.department_id"
                class="filter-item w-100"
                :placeholder="$t('department.department')"
              >
                <el-option
                  v-for="(department, index) in departments"
                  :key="index"
                  :label="department.name | uppercaseFirst"
                  :value="department.id"
                  :disabled="!department.is_active"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('municipality.name')" prop="name">
              <el-input v-model="currentMunicipalitie.name" />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align: right">
            <el-button plain type="danger" @click="dialogCreateMunicipalitie = false">
              {{ $t("permission.cancel") }}
            </el-button>
            <el-button
              type="primary"
              :loading="municipalitieCreating"
              @click="editing ? updateMunicipalitie() : createMunicipalitie()"
            >
              {{ municipalitieCreating ? $t("general.saving") : $t("general.save") }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <!-- ======= END Municipalitie FORM ======= -->
    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
const municipalitieResource = new Resource('municipalities');
const departmentResource = new Resource('departments');
export default {
  name: 'MunicipalitiesList',
  components: { Pagination },
  directives: { waves, permission, role },
  data() {
    return {
      departments: [],
      list: null,
      total: 0,
      loading: false,
      downloading: false,
      municipalitieCreating: false,
      editing: false,
      activeList: 'disponibles',
      query: {
        page: 1,
        limit: this.$limit,
        keyword: '',
      },
      currentMunicipalitie: {},
      dialogCreateMunicipalitie: false,
      currentMunicipalitieId: 0,
      rules: {
        name: [
          {
            required: true,
            message: this.$t('municipality.NameRequired'),
            trigger: 'blur',
          },
        ],
        department_id: [
          {
            required: true,
            message: this.$t('department.departmentRequired'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getDepartmentsList();
    this.resetNewMunicipalitie();
    this.getMunicipalitiesList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array) {
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseMunicipalitieCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    cancelMunicipalitieForm() {
      this.$refs.MunicipalitieCreationDrawer.closeDrawer();
    },
    initSearch() {
      this.query = {
        page: 1,
        limit: this.$limit,
        keyword: '',
      };
      this.activeList = 'disponibles';
      this.handleFilterMunicipalities();
    },
    async getMunicipalitiesList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await municipalitieResource.list(this.query);
      this.list = data;
      this.list.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    async getSubMunicipalitiesList(subUrl) {
      this.loading = true;
      const { data } = await municipalitieResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterMunicipalities() {
      this.query.page = 1;
      this.getMunicipalitiesList();
    },
    handleCreateMunicipalitie() {
      this.editing = false;
      this.resetNewMunicipalitie();
      this.dialogCreateMunicipalitie = true;
      this.$nextTick(() => {
        this.$refs['municipalitieForm'].clearValidate();
      });
    },
    handleEditMunicipalitie(id) {
      this.editing = true;
      this.resetNewMunicipalitie();
      this.currentMunicipalitie = this.list.find((abonne) => abonne.id === id);
      this.dialogCreateMunicipalitie = true;
      this.$nextTick(() => {
        this.$refs['municipalitieForm'].clearValidate();
      });
    },
    async setMunicipalitieStatus(id, type) {
      const data = await municipalitieResource.get('toogle_' + type + '/' + id);
      if (data.success) {
        this.$message({
          type: 'success',
          message: this.$t('general.statusUpdated'),
        });
        this.initSearch();
      } else {
        this.$message({
          type: 'danger',
          message: this.$t('general.statusUpdateError'),
        });
      }
    },
    handleDeleteMunicipalitie(id, visible, name) {
      this.$confirm(
        this.$t('municipality.deleteWarn') +
          ' ' +
          name +
          '. ' +
          this.$t('general.deleteContinue'),
        'Warning',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: this.$t('general.cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          if (
            !visible &&
            (checkRole(['Admin']) || checkPermission(['delete municipality']))
          ) {
            this.$swal({
              title: this.$t('general.SureQuestion'),
              text: this.$t('general.irrversibleMessage'),
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.$t('general.ouiSupprimer'),
            }).then((result) => {
              if (result.isConfirmed) {
                municipalitieResource
                  .destroy(id)
                  .then((response) => {
                    this.$message({
                      type: 'success',
                      message: this.$t('municipality.suppressionEffectue'),
                    });
                    this.initSearch();
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            });
          } else {
            this.setMunicipalitieStatus(id, 'visible');
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general.suppressionAnnule'),
          });
        });
    },
    createMunicipalitie() {
      this.$refs['municipalitieForm'].validate((valid) => {
        if (valid) {
          this.municipalitieCreating = true;
          municipalitieResource
            .store(this.currentMunicipalitie)
            .then(async(response) => {
              this.$message({
                message:
                  this.$t('municipality.NewMunicipalitie') +
                  ' ' +
                  this.currentMunicipalitie.name +
                  ' ' +
                  this.$t('municipality.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentMunicipalitieId = response.data.id;
              this.resetNewMunicipalitie();
              this.dialogCreateMunicipalitie = false;
              this.handleFilterMunicipalities();
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.municipalitieCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    updateMunicipalitie() {
      this.$refs['municipalitieForm'].validate((valid) => {
        if (valid) {
          this.municipalitieCreating = true;
          municipalitieResource
            .update(this.currentMunicipalitie.id, this.currentMunicipalitie)
            .then((response) => {
              this.resetNewMunicipalitie();
              this.handleFilterMunicipalities();
              this.$message({
                message: this.$t('municipality.isupdatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.dialogCreateMunicipalitie = false;
              this.editing = false;
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.municipalitieCreating = false;
            });
        } else {
          this.$message({
            type: 'danger',
            message: this.$t('general.invalidForm'),
          });
          return false;
        }
      });
    },
    resetNewMunicipalitie() {
      this.currentMunicipalitie = {
        name: '',
      };
    },
    async getDepartmentsList() {
      this.loading = true;
      const { limit, page } = this.query;
      const { data, meta } = await departmentResource.list(this.query);
      this.departments = data;
      this.departments.forEach((element, index) => {
        element['index'] = (page - 1) * limit + index + 1;
      });
      this.total = meta.total;
      this.loading = false;
    },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'ID',
          this.$t('municipality.name'),
          this.$t('department.department'),
        ];
        const filterVal = ['id', 'name', 'department_id'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename:
            'Municipalities list GEOSANTE_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },

    // Importation
    // Importation
    handleImportMunicipalities() {
      // Ouvre le sélecteur de fichier
      this.$refs.fileInput.click();
    },

    async onFileChange(event) {
      console.log('onFileChange');
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      try {
        // Utilisez XLSX pour lire le fichier Excel
        const XLSX = await import('xlsx');
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });

          // Supposons que les données sont dans la première feuille
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];

          // Convertir les données en JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: ['code', 'name', 'department'],
            range: 1,
          });

          // Valider et envoyer les données au backend
          this.uploadMunicipalities(jsonData);
        };

        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.error('Erreur lors de la lecture du fichier Excel:', error);
        this.$message.error(this.$t('general.importError'));
      }
    },

    async uploadMunicipalities(municipalities) {
      try {
        // Envoyer les données au backend
        const response = await municipalitieResource.substore(
          '/import',
          municipalities
        );

        if (response.success) {
          this.$message.success(this.$t('municipality.importSuccess'));
          this.getMunicipalitiesList(); // Rafraîchir la liste des départements
        } else {
          this.$message.error(this.$t('municipality.importError'));
        }
      } catch (error) {
        console.error('Erreur lors de l\'importation des municipalités:', error);
        this.$message.error(this.$t('municipality.importError'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.half-right {
  width: 70% !important;
  float: none !important;
  text-align: left !important;
  padding: 10px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
